import React from 'react'
export type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

type Props = {
  title?: string
  headingLevel?: HeadingLevel
}
const Kheader: React.FC<Props> = ({ title, headingLevel = 'h2' }) => {
  const Title = headingLevel
  return <Title>{title}</Title>
}

export default Kheader
